import { db } from '@/shared/services/firebase'
import i18n from '@hw-core/libs/i18n'
import store from '@/shared/store'

const header =   {
  header: i18n.t('mainMenu.pay_and_bill'),
  resource: 'Payroll',
  action: 'read',
}
const menuItems = [
  {
    title: i18n.t('quickShifts.titles.menu_item'),
    icon: 'ZapIcon',
    resource: 'Quickpay',
    action: 'read',
    children: [
      {
        title: i18n.t('quickShifts.titles.submenu_pending'),
        route: 'apps-quick-shifts-pending',
        action: 'read',
        resource: 'Quickpay',
        watchBadgeCount: ({ onlyAreas, callback }) => {
          db.collection('shifts')
            .where('end', '<=', new Date())
            .where('status', '==', 'confirmed')
            .where('boostedOptions.boostType', '==', 'quick')
            .where('finalConfirmation.confirmed', '==', false)
            .where('confirmationRequest', '==', '')
            .onSnapshot(snapshot => { // snapshot continuously checking the db for changes
              const changes = snapshot.docChanges()
              changes.forEach(change => {
                const data = { ...change.doc.data(), id: change.doc.id }
                if (onlyAreas && onlyAreas.indexOf(data.areaId) === -1) {
                  return
                }
                callback(change)
              })
            })
        },
      },
      {
        title: i18n.t('quickShifts.titles.submenu_sent'),
        route: 'apps-quick-shifts-sent',
        action: 'read',
        resource: 'Quickpay',
        watchBadgeCount: ({ role, callback }) => {
          if (role !== 'admin') {
            return
          }
          db.collection('clientRequests')
            .where('type', '==', 'quick_shifts_confirmation')
            .where('status', 'in', ['open', 'pending'])
            .orderBy('createdAt', 'desc')
            .onSnapshot(snapshot => {
              const changes = snapshot.docChanges()
              changes.forEach(change => {
                callback(change)
              })
            })
        },
      },
      {
        title: i18n.t('quickShifts.titles.submenu_paying'),
        route: 'apps-quick-shifts-paying',
        action: 'read',
        resource: 'Quickpay',
        watchBadgeCount: ({ callback }) => {
          db.collection('payrolls')
            .where('status', '==', 'pending')
            .where('type', '==', 'quick')
            .onSnapshot(snapshot => {
              const changes = snapshot.docChanges()
              changes.forEach(change => {
                callback(change)
              })
            })
        },
      },
    ],
    watchBadgeCount: ({
      role, onlyAreas, callback,
    }) => {
      db.collection('shifts')
        .where('end', '<=', new Date())
        .where('status', '==', 'confirmed')
        .where('boostedOptions.boostType', '==', 'quick')
        .where('finalConfirmation.confirmed', '==', false)
        .where('confirmationRequest', '==', '')
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          changes.forEach(change => {
            const data = { ...change.doc.data(), id: change.doc.id }
            if (onlyAreas && onlyAreas.indexOf(data.areaId) === -1) {
              return
            }
            callback(change)
          })
        })
      if (role !== 'admin') {
        return
      }
      db.collection('clientRequests')
        .where('type', '==', 'quick_shifts_confirmation')
        .where('status', 'in', ['open', 'pending'])
        .orderBy('createdAt', 'desc')
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          changes.forEach(change => {
            callback(change)
          })
        })
      db.collection('payrolls')
        .where('status', '==', 'pending')
        .where('type', '==', 'quick')
        .onSnapshot(snapshot => {
          const changes = snapshot.docChanges()
          changes.forEach(change => {
            callback(change)
          })
        })
    },
  },
  {
    title: i18n.t('invoices.titles.menu_item'),
    route: 'apps-invoices-list',
    icon: 'FileTextIcon',
    resource: 'Invoices',
    action: 'read',
  },
  {
    title: i18n.t('payrolls.titles.menu_item'),
    route: 'apps-payrolls-list',
    icon: 'ClipboardIcon',
    resource: 'Payroll',
    action: 'read',
  },
  store.state.app.appConfig.type === 'hw-admin' ? {
    title: i18n.t('agreements.titles.menu_item'),
    icon: 'EditIcon',
    resource: 'Payroll',
    action: 'read',
    children: [
      {
        title: i18n.t('agreements.titles.submenu_contracts'),

        route: 'apps-contracts-list',
        action: 'read',
        resource: 'HR',
      },
      {
        title: i18n.t('agreements.titles.submenu_campaigns'),
        route: 'apps-campaigns-list',
        action: 'read',
        resource: 'Campaigns',
      },
    ],
  } : {
    title: i18n.t('agreements.titles.menu_item'),
    route: 'apps-contracts-list',
    icon: 'EditIcon',
    resource: 'Payroll',
    action: 'read',
  },
]

export default { header, menuItems }